var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getDemoActivityLabelNamesWithUncategorized } from '@web/lib/demo/data/labels';
import { diffComparisonType } from '@workalizer/shared/types';
import { getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var comparisonCountFromDiffString = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    if (pct === 0) {
        return current;
    }
    return Math.round(current / (1 + pct / 100));
};
var buildTeamAvgDiff = function (current, diffString) {
    var teamAvg = comparisonCountFromDiffString(current, diffString);
    return getPercentageDiff(teamAvg, current, {
        comparisonType: diffComparisonType.teamAverage
    });
};
var buildMetricDiffs = function (count, diffs) { return ({
    previousPeriod: getPercentageDiff(comparisonCountFromDiffString(count, diffs.prev), count),
    teamAverage: buildTeamAvgDiff(count, diffs.team)
}); };
var docsSharedExternallyByLabelRows = [
    {
        counts: {
            documents: 5,
            spreadsheets: 3,
            presentations: 2,
            pdfs: 1,
            other: 1
        },
        diffs: {
            documents: { prev: '+25%', team: '+10%' },
            spreadsheets: { prev: '0%', team: '-15%' },
            presentations: { prev: '+50%', team: '+20%' },
            pdfs: { prev: '-50%', team: '-30%' },
            other: { prev: '+100%', team: '+35%' }
        }
    },
    {
        counts: {
            documents: 2,
            spreadsheets: 4,
            presentations: 1,
            pdfs: 0,
            other: 2
        },
        diffs: {
            documents: { prev: '-33%', team: '-20%' },
            spreadsheets: { prev: '+33%', team: '+12%' },
            presentations: { prev: '0%', team: '-25%' },
            pdfs: { prev: '0%', team: '0%' },
            other: { prev: '+100%', team: '+40%' }
        }
    },
    {
        counts: {
            documents: 7,
            spreadsheets: 1,
            presentations: 3,
            pdfs: 2,
            other: 0
        },
        diffs: {
            documents: { prev: '+17%', team: '+8%' },
            spreadsheets: { prev: '-50%', team: '-18%' },
            presentations: { prev: '+200%', team: '+45%' },
            pdfs: { prev: '+100%', team: '+22%' },
            other: { prev: '0%', team: '0%' }
        }
    }
];
export var docsSharedExternallyByLabel = function (_input) {
    return getDemoActivityLabelNamesWithUncategorized().map(function (labelName, index) {
        var row = docsSharedExternallyByLabelRows[index % docsSharedExternallyByLabelRows.length];
        var counts = {
            documents: row.counts.documents + randomInt(0, 2),
            spreadsheets: row.counts.spreadsheets + randomInt(0, 2),
            presentations: row.counts.presentations + randomInt(0, 1),
            pdfs: row.counts.pdfs,
            other: row.counts.other
        };
        return __assign(__assign({ labelName: labelName }, counts), { previousPeriod: {
                documents: buildMetricDiffs(counts.documents, row.diffs.documents)
                    .previousPeriod,
                spreadsheets: buildMetricDiffs(counts.spreadsheets, row.diffs.spreadsheets).previousPeriod,
                presentations: buildMetricDiffs(counts.presentations, row.diffs.presentations).previousPeriod,
                pdfs: buildMetricDiffs(counts.pdfs, row.diffs.pdfs).previousPeriod,
                other: buildMetricDiffs(counts.other, row.diffs.other).previousPeriod
            }, teamAverage: {
                documents: buildMetricDiffs(counts.documents, row.diffs.documents)
                    .teamAverage,
                spreadsheets: buildMetricDiffs(counts.spreadsheets, row.diffs.spreadsheets).teamAverage,
                presentations: buildMetricDiffs(counts.presentations, row.diffs.presentations).teamAverage,
                pdfs: buildMetricDiffs(counts.pdfs, row.diffs.pdfs).teamAverage,
                other: buildMetricDiffs(counts.other, row.diffs.other).teamAverage
            } });
    });
};
